import { PlatformType } from '../const/alertsConfig';
export default (function (platform) {
    return platform === PlatformType.PEAKS;
});
